import { Component } from '@angular/core';
import { NavController, NavParams, Platform, LoadingController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { provider } from '../../providers/provider';
// import { HomePage } from '../home/home';

@Component({
  selector: 'page-success',
  templateUrl: 'success.html',
})
export class Success {
  message:any;
  righe:any;
  tot:any;
  valuta:any;
  summary:any;
  takeAway:any;
  deliveryCost:any;
  deliveryDiscount:any;

  constructor(public navCtrl: NavController,
              public loadingCtrl: LoadingController,
              public provider: provider,
              public storage: Storage,
              public navParams: NavParams,
              public translateService: TranslateService, 
              public platform: Platform) {

    this.message = navParams.get('message');
    this.summary = provider.getCart();
    this.tot = navParams.get('tot');
    this.valuta = navParams.get('valuta');
    this.takeAway = navParams.get('takeaway');
    this.deliveryCost = navParams.get('deliveryCost');
    this.deliveryDiscount = navParams.get('deliveryDiscount');

    platform.registerBackButtonAction(() => this.clear());
  }

  clear() {
    this.provider.clearApp();
    // this.navCtrl.push(HomePage);
    let loading = this.loadingCtrl.create({
      content: '<ion-spinner name="circles"></ion-spinner>'
    });
    loading.present().then(() => {
      window.location.reload();
    });
  } 
}



// WEBPACK FOOTER //
// ./src/pages/success/success.ts